var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"citsci-project-icon",style:(_vm.iconStyle),attrs:{"src":"/assets/images/svg/CitSci_icon_BW.svg","alt":"CitSci Project"}})}
var staticRenderFns = []
export { render, staticRenderFns }